import type { TFunction } from 'i18next';

export const getDeleteMessageIfUsedBy = ({ deals, floors, t }: { deals: boolean; floors: boolean; t: TFunction }) => {
  if (deals && floors) {
    return t('This package cannot be deleted, as it is associated with one or more active deals and brand floors.');
  }

  if (deals) {
    return t('This package cannot be deleted, as it is associated with one or more active deals.');
  }

  if (floors) {
    return t('This package cannot be deleted, as it is associated with one or more brand floors.');
  }
};
